import { Observable, from } from 'rxjs';

/**
 * Lazy, cancellable `from(apiClient.get(...))`: the request starts on subscribe and is aborted on
 * unsubscribe, so a request superseded by `switchMap` is cancelled instead of completing anyway.
 *
 * Usage: `fromApiRequest((signal) => apiClient.get(ApiType.x, { url, signal }))`
 */
export const fromApiRequest = <T>(request: (signal: AbortSignal) => Promise<T>): Observable<T> =>
  new Observable<T>((subscriber) => {
    const controller = new AbortController();
    const subscription = from(request(controller.signal)).subscribe(subscriber);

    return () => {
      subscription.unsubscribe();
      controller.abort();
    };
  });
